// localStorage / sessionStorage can throw: even reading window.localStorage raises a
// SecurityError when site data is blocked, and setItem throws when the quota is
// exceeded or in some private windows. Nothing stored here is essential, so failures
// are swallowed: reads return null (or the fallback) and writes report false.

const area = (kind) => {
  try {
    return window[kind];
  } catch (err) {
    return null;
  }
};

const createSafeStorage = (kind) => ({
  getItem(key) {
    try {
      return area(kind)?.getItem(key) ?? null;
    } catch (err) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      area(kind).setItem(key, value);
      return true;
    } catch (err) {
      return false;
    }
  },
  removeItem(key) {
    try {
      area(kind).removeItem(key);
      return true;
    } catch (err) {
      return false;
    }
  },
  // JSON convenience: returns `fallback` when the key is missing, unreadable or not valid JSON.
  getJSON(key, fallback) {
    const raw = this.getItem(key);
    if (raw === null) return fallback;
    try {
      return JSON.parse(raw);
    } catch (err) {
      return fallback;
    }
  },
  setJSON(key, value) {
    return this.setItem(key, JSON.stringify(value));
  },
});

export const safeLocalStorage = createSafeStorage('localStorage');
export const safeSessionStorage = createSafeStorage('sessionStorage');
